// eslint-disable-next-line no-restricted-imports
import { usePaginatedList } from '../Provider'
import SearchBar from 'components/Commons/Search'

export const FILTERS = {
  SEARCH: 'searchText',
  IDS: 'ids',
}

export function Search({
  className,
  placeholder,
  SearchComponent = SearchBar,
  maxLength = null,
  sortOnSearch,
  size,
  disabled,
}) {
  const { filters, setFiltersAndSort } = usePaginatedList()
  return (
    <SearchComponent
      className={className}
      value={filters[FILTERS.SEARCH]?.toString() ?? ''}
      placeholder={placeholder}
      onChange={v => setFiltersAndSort({ filters: { [FILTERS.SEARCH]: v }, sort: sortOnSearch })}
      maxLength={maxLength}
      size={size}
      disabled={disabled}
      dataTestId="input_search"
    />
  )
}
